import { makeAutoObservable } from "mobx";
import PagesService from "../service/PagesService";
import { IPages } from "../models/IPages";
import {
  showErrorToast,
  showLoadingToast,
  showSuccessToast,
} from "../components/toasts";

export default class Pages {
  pageContent: IPages[] = [];
  loadingContentBool: boolean = false;

  constructor() {
    makeAutoObservable(this);
  }

  setContent(content: IPages[]) {
    this.pageContent = content;
  }

  async loadList(type: string) {
    this.loadingContentBool = true;
    const PageList = await PagesService.fetchPageContent(type);
    this.setContent(PageList.data);
    // @ts-ignore
    // if (PageList.data?.content.length === 0) {
    //   this.createOne({
    //     type: type,
    //     content: [],
    //   });
    // }
    this.loadingContentBool = false;
    return PageList.data;
  }

  async createOne(data: { type: string; content: any } | undefined) {
    this.loadingContentBool = true;
    if (typeof data !== "undefined") {
      await PagesService.fetchCreateOne(data);
      // await this.loadList(data?.type);
    } else {
      console.error("no data to send");
    }
    this.loadingContentBool = false;
  }

  async updateOne(type: string, data: FormData | undefined) {
    this.loadingContentBool = true;
    showLoadingToast("Updating page content...");
    if (typeof data !== "undefined") {
      await PagesService.fetchUpdateOne(data, type);
      await this.loadList(type);
      showSuccessToast("Page content updated");
    } else {
      console.log("no data to update");
      showErrorToast("Error updating page content");
    }
    this.loadingContentBool = false;
  }

  async testFormData(type: string, data: FormData | undefined) {
    this.loadingContentBool = true;
    if (typeof data !== "undefined") {
      await PagesService.testFormData(type, data);
      await this.loadList(type);
    } else {
      console.log("no data to update");
    }
    this.loadingContentBool = false;
  }

}
